import { ResStatus } from 'api/api.types';
import { AxiosResponse } from 'axios';
import _ from 'lodash';

export const fieldIsRequired = {
  required: true,
  validate: (v: any) => !_.isEmpty(v),
};

export const getIds = (item: any) =>
  Array.isArray(item) ? item.map((i) => i.id) : item.id;

export const isSuccessful = <R>(
  res: AxiosResponse<
    {
      status: ResStatus;
      message: string;
      data: { status: string };
    },
    any
  >,
) => res.data.status === ResStatus.OK;
